function initMatchHeight() {
	$.fn.matchHeight._maintainScroll = true;
	$.fn.matchHeight._applyDataApi();
}

function matchHeightReset() {
	$('[data-mh]').matchHeight({ remove: true });
	initMatchHeight();
}